import { SET_LOADING } from "./types";
import { NotificationService } from "../../services/NotificationService";

/**
 * @author Vikrant.
 * @since 23-05-2025.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

/**
 * @author Vikrant.
 * @since 23-05-2025.
 * @description to send notification
 */
export const sendNotification =
  (data, params, successCallback, errorCallback) => async (dispatch) => {
    dispatch(setLoading(true));

    await NotificationService.sendNotifications(data, params)
      .then(async (res) => {
        console.log("Result: ", res);

        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in adding project: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
